/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Otp } from "./Otp";
import * as t from "io-ts";
import { UTCISODateFromString } from "@pagopa/ts-commons/lib/dates";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum StatusEnum {
  "ANONYMOUS" = "ANONYMOUS",

  "REGISTERED" = "REGISTERED",

  "REGISTERED_SPID" = "REGISTERED_SPID",

  "REGISTERED_CIE" = "REGISTERED_CIE",

  "NEED_OTP" = "NEED_OTP",

  "NEED_PASSWORD" = "NEED_PASSWORD",

  "WAITING_NEW_PASSWORD" = "WAITING_NEW_PASSWORD",

  "DELETED" = "DELETED"
}

// required attributes
const UserR = t.interface({});

// optional attributes
const UserO = t.partial({
  acceptTerms: t.boolean,

  activationDate: UTCISODateFromString,

  cellphone: t.string,

  cellphoneVerified: t.boolean,

  email: t.string,

  emailVerified: t.boolean,

  fiscalCode: t.string,

  name: t.string,

  notificationEmail: t.string,

  otp: Otp,

  puk: t.string,

  registeredDate: UTCISODateFromString,

  spidSessionId: t.Integer,

  status: enumType<StatusEnum>(StatusEnum, "status"),

  surname: t.string,

  temporaryCellphone: t.string,

  username: t.string
});

export const User = t.intersection([UserR, UserO], "User");

export type User = t.TypeOf<typeof User>;
